/**
 * @license
 * Beleza na Web v0.2.60
 *
 */
import { ONE_MONTH } from '@belezanaweb/utils/constants';
import { cookiePrefix, createCookie, getCookieByName } from './utils/cookie';
export * from './utils/cookie';

var filterTestsToCreate = function filterTestsToCreate(test) {
  var previusCookieValue = getCookieByName("".concat(cookiePrefix, "-").concat(test.name));
  var hasOtherValue = !test.values.includes(previusCookieValue);
  var testIsNtRunning = !getCookieByName(cookiePrefix).split(',').includes(test.name);
  return testIsNtRunning || hasOtherValue;
};

var createCookieByTest = function createCookieByTest(_ref) {
  var name = _ref.name,
      values = _ref.values,
      percentage = _ref.percentage,
      time = _ref.time;
  var percentageOfTheFirstTestVariant = percentage || 0;
  var setFirstVariation = Math.random() <= percentageOfTheFirstTestVariant / 100;
  var value = setFirstVariation ? values[0] : values[1];
  createCookie({
    name: name,
    value: value,
    time: time
  });
};

export var init = function init() {
  var tests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  tests.filter(filterTestsToCreate).forEach(createCookieByTest);
  var testsNames = tests.map(function (test) {
    return test.name;
  }).join(',');
  createCookie({
    name: cookiePrefix,
    value: testsNames,
    time: ONE_MONTH
  });
};